<template>
  <li v-if="isVisible()" class="item">
    <slot>
      <span class="label">{{ label }}:</span>
      <span class="content" v-html="theContent()"></span>
    </slot>
  </li>
</template>

<script>
export default {
  name: "MediaDetailsListItem",

  props: {
    label: '',
    content: '',
    conditional: {
      default: '___NA___'
    }
  },

  data() {
    return {};
  },

  methods: {
    theContent() {
      const arrayUnique = (value, index, self) => self.indexOf(value) === index;

      if (typeof this.content === 'object') {
        try {
          return this.content.filter(arrayUnique).join(', ');
        } catch (e) {
        }
      }
      return this.content;
    },

    isVisible() {
      if (this.conditional === '___NA___') {
        return this.content && this.content.length > 0;
      }

      return this.conditional && this.conditional.length > 0;
    }
  }
}
</script>

<style lang="scss" scoped>

.item {

}

.label {
  font-weight: 700;
  white-space: nowrap;
  margin-right: .3rem;
}

.content {
  word-break: break-word;
}

</style>